import React, { useState } from "react";
import ModalPostulaciones from "./ModalPostulaciones";
import { Button } from "../../components/ui/button";
import {
  Sheet,
  SheetTrigger,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from "../../components/ui/sheet";

const FiltroPostulaciones = ({
  filters = {},
  setFilters,
  applications,
  tenders,
  companies,
  onClearFilters,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeFilter, setActiveFilter] = useState("");
  const [showFiltersMenu, setShowFiltersMenu] = useState(false);

  const optionsData = {
    id_application: [...applications]
      .sort((a, b) => a.id_application - b.id_application)
      .map((app) => ({
        label: `ID ${app.id_application}`,
        value: app.id_application,
      })),
    id_tender: tenders.map((tender) => ({
      label: `ID ${tender.id_tender} - ${
        tender.titulo.length > 30
          ? tender.titulo.substring(0, 30) + "..."
          : tender.titulo
      }`,
      value: tender.id_tender,
    })),

    id_licitador: companies.map((company) => ({
      label: company.nombre_empresa, // 🔹 Directamente desde `companies`
      value: company.id_company, // 🔹 Puede ser un ID de empresa o de usuario
    })),

    estado: [
      { label: "Aceptada", value: "aceptada" },
      { label: "Rechazada", value: "rechazada" },
      { label: "En revisión", value: "en revisión" },
    ],
    fecha: [
      { label: "Últimas 24 horas", value: "last_24_hours" },
      { label: "Semana pasada", value: "last_week" },
      { label: "Mes pasado", value: "last_month" },
    ],
  };

  const friendlyTitles = {
    id_application: "ID de Postulación", // 🔹 Agregado nuevo filtro
    id_tender: "ID de Licitación",
    id_licitador: "Licitador",
    estado: "Estado de la Postulación",
    fecha: "Fecha de Postulación",
  };

  const handleFilterClick = (filterType) => {
    setActiveFilter(filterType);
    setIsModalOpen(true);
  };

  const handleModalApply = (filterType, value) => {
    if (JSON.stringify(filters[filterType]) === JSON.stringify(value)) return; // No actualizar si es lo mismo

    setFilters((prevFilters) => ({
      ...prevFilters,
      [filterType]: value,
    }));
    setIsModalOpen(false);
  };

  const isFilterActive = (filterType) =>
    Array.isArray(filters[filterType]) && filters[filterType].length > 0;

  return (
    <div className="mb-6 flex flex-wrap items-center gap-2">
      <div className="hidden flex-wrap items-center gap-2 md:flex">
        {Object.keys(friendlyTitles).map((filterType) => (
          <Button
            key={filterType}
            variant={isFilterActive(filterType) ? "default" : "outline"}
            onClick={() => handleFilterClick(filterType)}
          >
            {friendlyTitles[filterType]}
          </Button>
        ))}
        <Button variant="ghost" onClick={onClearFilters}>
          Limpiar Filtros
        </Button>
      </div>

      <Sheet open={showFiltersMenu} onOpenChange={setShowFiltersMenu}>
        <SheetTrigger asChild>
          <Button variant="outline" className="md:hidden">
            Mostrar filtros
          </Button>
        </SheetTrigger>
        <SheetContent side="left">
          <SheetHeader>
            <SheetTitle>Todos los filtros</SheetTitle>
          </SheetHeader>
          <div className="flex flex-col gap-2">
            {Object.keys(friendlyTitles).map((filterType) => (
              <Button
                key={filterType}
                variant={isFilterActive(filterType) ? "default" : "outline"}
                className="w-full justify-start"
                onClick={() => handleFilterClick(filterType)}
              >
                {friendlyTitles[filterType]}
              </Button>
            ))}
          </div>
          <div className="mt-4 flex flex-col gap-2 border-t border-border pt-4">
            <Button onClick={() => setShowFiltersMenu(false)}>Aplicar Filtros</Button>
            <Button variant="outline" onClick={onClearFilters}>
              Limpiar Filtros
            </Button>
          </div>
        </SheetContent>
      </Sheet>

      {isModalOpen && (
        <ModalPostulaciones
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          options={optionsData[activeFilter] || []}
          selectedOptions={filters[activeFilter] || []}
          setSelectedOptions={(newOptions) =>
            handleModalApply(activeFilter, newOptions)
          }
          title={`Seleccionar ${friendlyTitles[activeFilter] || activeFilter}`}
        />
      )}
    </div>
  );
};

export default FiltroPostulaciones;
